import React, { useContext, useState } from 'react'
import { CaseContext } from '@broker-crm-contexts'
import { Box } from '@mui/material'
import { useIntl } from 'react-intl'

import { isGeneralProtection, isHomeInsurance, LazyReact, useUserContext } from '@acre/utils'
import { Case, useGeneralInsuranceProductsQuery, useGetOrganisationQuery, User } from '@acre/graphql'

import { setInitialReminderValues, TasksLocation } from './CaseOverview.helpers'
import CaseVerifications from './TaskManagement/CaseVerifications'
import { getCaseSelectedMortgage, getEarliestGIProductEndDate } from './TaskManagement/CaseVerifications.helpers'

const AddReminderModal = LazyReact(() => import('../../../Reminders/AddReminder'))

type Props = {
  tasksLocation?: TasksLocation
}

const VerificationsContainer = ({ tasksLocation }: Props) => {
  const [isModalOpenReminders, setModalOpenReminders] = useState(false)

  const user = useUserContext()
  const intl = useIntl()

  const caseVersion = useContext(CaseContext)
  const clientIds = caseVersion.details?.clients.map((client) => client.id)

  const isProtectionCase = isGeneralProtection(caseVersion.details.preference_mortgage_reason)
  const isHomeInsuranceCase = isHomeInsurance(caseVersion.details.preference_mortgage_reason)

  const mortgage = caseVersion.details && getCaseSelectedMortgage(caseVersion.details as Case)

  const { data: lenderData } = useGetOrganisationQuery({
    variables: { id: mortgage?.mortgage_product?.lender_reference! },
    skip: !mortgage?.mortgage_product?.lender_reference,
  })
  const lenderName = (lenderData?.organisation && lenderData?.organisation.name) || ''

  const { data: giProductsOnCaseData } = useGeneralInsuranceProductsQuery({
    variables: {
      input: {
        filter_case_ids: [caseVersion.id],
      },
    },
    skip: !isHomeInsuranceCase,
  })
  const earliestGIProductEndDate = getEarliestGIProductEndDate(
    giProductsOnCaseData?.generalInsuranceProducts?.general_insurance_products || [],
  )

  const initialValues = setInitialReminderValues(
    caseVersion.details as Case,
    user as User,
    intl,
    lenderName,
    earliestGIProductEndDate,
  )

  return (
    <>
      <Box
        display="flex"
        flex="1"
        alignSelf="flex-start"
        ml={tasksLocation === TasksLocation.CaseSidebarDrawer ? 0 : 2}
        flexDirection="column"
      >
        <CaseVerifications
          caseId={caseVersion.id}
          clientIds={clientIds}
          onCompleteCase={() => setModalOpenReminders(true)}
          caseStatus={caseVersion.details.status!}
          tasksLocation={tasksLocation}
        />
      </Box>
      <AddReminderModal
        initialValues={initialValues}
        modalOpen={isModalOpenReminders}
        setModalOpen={setModalOpenReminders}
        ignorePristine
        layout="review"
        isProtection={isProtectionCase}
        isHomeInsurance={isHomeInsuranceCase}
      />
    </>
  )
}

export default VerificationsContainer
